import { render, staticRenderFns } from "./LanguageHeader.vue?vue&type=template&id=da16e6d2"
import script from "./LanguageHeader.vue?vue&type=script&lang=js"
export * from "./LanguageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports